// @ts-nocheck

import backflowDeviceAsset from '@atom/components/common/svgIcons/backflowDeviceAsset.svg';
import backflowDeviceAssetActive from '@atom/components/common/svgIcons/backflowDeviceAssetActive.svg';
import barrierAsset from '@atom/components/common/svgIcons/barrierAsset.svg';
import barrierAssetActive from '@atom/components/common/svgIcons/barrierAssetActive.svg';
import basinAsset from '@atom/components/common/svgIcons/basinAsset.svg';
import basinAssetActive from '@atom/components/common/svgIcons/basinAssetActive.svg';
import benchAsset from '@atom/components/common/svgIcons/benchAsset.svg';
import benchAssetActive from '@atom/components/common/svgIcons/benchAssetActive.svg';
import bikeAsset from '@atom/components/common/svgIcons/bikeAsset.svg';
import bikeAssetActive from '@atom/components/common/svgIcons/bikeAssetActive.svg';
import boatAsset from '@atom/components/common/svgIcons/boatAsset.svg';
import boatAssetActive from '@atom/components/common/svgIcons/boatAssetActive.svg';
import bollardsAsset from '@atom/components/common/svgIcons/bollardsAsset.svg';
import bollardsAssetActive from '@atom/components/common/svgIcons/bollardsAssetActive.svg';
import bookmarkAsset from '@atom/components/common/svgIcons/bookmarkAsset.svg';
import bookmarkAssetActive from '@atom/components/common/svgIcons/bookmarkAssetActive.svg';
import bridgeAsset from '@atom/components/common/svgIcons/bridgeAsset.svg';
import bridgeAssetActive from '@atom/components/common/svgIcons/bridgeAssetActive.svg';
import brushAsset from '@atom/components/common/svgIcons/brushAsset.svg';
import brushAssetActive from '@atom/components/common/svgIcons/brushAssetActive.svg';
import buildingAsset from '@atom/components/common/svgIcons/buildingAsset.svg';
import buildingAssetActive from '@atom/components/common/svgIcons/buildingAssetActive.svg';
import buildingBlackAsset from '@atom/components/common/svgIcons/buildingBlackAsset.svg';
import buildingBlackAssetActive from '@atom/components/common/svgIcons/buildingBlackAssetActive.svg';
import buildingHydrantBlackAsset from '@atom/components/common/svgIcons/buildingHydrantBlackAsset.svg';
import buildingHydrantBlackAssetActive from '@atom/components/common/svgIcons/buildingHydrantBlackAssetActive.svg';
import buildingHydrantBlueAsset from '@atom/components/common/svgIcons/buildingHydrantBlueAsset.svg';
import buildingHydrantBlueAssetActive from '@atom/components/common/svgIcons/buildingHydrantBlueAssetActive.svg';
import buildingHydrantPinkAsset from '@atom/components/common/svgIcons/buildingHydrantPinkAsset.svg';
import buildingHydrantPinkAssetActive from '@atom/components/common/svgIcons/buildingHydrantPinkAssetActive.svg';
import buildingOrangeAsset from '@atom/components/common/svgIcons/buildingOrangeAsset.svg';
import buildingOrangeAssetActive from '@atom/components/common/svgIcons/buildingOrangeAssetActive.svg';
import buildingPurpleAsset from '@atom/components/common/svgIcons/buildingPurpleAsset.svg';
import buildingPurpleAssetActive from '@atom/components/common/svgIcons/buildingPurpleAssetActive.svg';
import bulbAsset from '@atom/components/common/svgIcons/bulbAsset.svg';
import bulbAssetActive from '@atom/components/common/svgIcons/bulbAssetActive.svg';
import bumpAsset from '@atom/components/common/svgIcons/bumpAsset.svg';
import bumpAssetActive from '@atom/components/common/svgIcons/bumpAssetActive.svg';
import busAsset from '@atom/components/common/svgIcons/busAsset.svg';
import busAssetActive from '@atom/components/common/svgIcons/busAssetActive.svg';
import cleanOutAsset from '@atom/components/common/svgIcons/cleanOutAsset.svg';
import cleanOutAssetActive from '@atom/components/common/svgIcons/cleanOutAssetActive.svg';
import coneAsset from '@atom/components/common/svgIcons/coneAsset.svg';
import coneAssetActive from '@atom/components/common/svgIcons/coneAssetActive.svg';
import controlValveAsset from '@atom/components/common/svgIcons/controlValveAsset.svg';
import controlValveAssetActive from '@atom/components/common/svgIcons/controlValveAssetActive.svg';
import countAsset from '@atom/components/common/svgIcons/countAsset.svg';
import countAssetActive from '@atom/components/common/svgIcons/countAssetActive.svg';
import crossAsset from '@atom/components/common/svgIcons/crossAsset.svg';
import crossAssetActive from '@atom/components/common/svgIcons/crossAssetActive.svg';
import culvertAsset from '@atom/components/common/svgIcons/culvertAsset.svg';
import culvertAssetActive from '@atom/components/common/svgIcons/culvertAssetActive.svg';
import curbAsset from '@atom/components/common/svgIcons/curbAsset.svg';
import curbAssetActive from '@atom/components/common/svgIcons/curbAssetActive.svg';
import curbStopAsset from '@atom/components/common/svgIcons/curbStopAsset.svg';
import curbStopAssetActive from '@atom/components/common/svgIcons/curbStopAssetActive.svg';
import deviceAsset from '@atom/components/common/svgIcons/deviceAsset.svg';
import deviceAssetActive from '@atom/components/common/svgIcons/deviceAssetActive.svg';
import diamondAsset from '@atom/components/common/svgIcons/diamondAsset.svg';
import diamondAssetActive from '@atom/components/common/svgIcons/diamondAssetActive.svg';
import diamondBlueAsset from '@atom/components/common/svgIcons/diamondBlueAsset.svg';
import diamondBlueAssetActive from '@atom/components/common/svgIcons/diamondBlueAssetActive.svg';
import ditchAsset from '@atom/components/common/svgIcons/ditchAsset.svg';
import ditchAssetActive from '@atom/components/common/svgIcons/ditchAssetActive.svg';
import dotAsset from '@atom/components/common/svgIcons/dotAsset.svg';
import dotAssetActive from '@atom/components/common/svgIcons/dotAssetActive.svg';
import dotBlueAsset from '@atom/components/common/svgIcons/dotBlueAsset.svg';
import dotBlueAssetActive from '@atom/components/common/svgIcons/dotBlueAssetActive.svg';
import dotGreenAsset from '@atom/components/common/svgIcons/dotGreenAsset.svg';
import dotGreenAssetActive from '@atom/components/common/svgIcons/dotGreenAssetActive.svg';
import dotOrangeAsset from '@atom/components/common/svgIcons/dotOrangeAsset.svg';
import dotOrangeAssetActive from '@atom/components/common/svgIcons/dotOrangeAssetActive.svg';
import downAsset from '@atom/components/common/svgIcons/downAsset.svg';
import downAssetActive from '@atom/components/common/svgIcons/downAssetActive.svg';
import fanAsset from '@atom/components/common/svgIcons/fanAsset.svg';
import fanAssetActive from '@atom/components/common/svgIcons/fanAssetActive.svg';
import fanBlueAsset from '@atom/components/common/svgIcons/fanBlueAsset.svg';
import fanBlueAssetActive from '@atom/components/common/svgIcons/fanBlueAssetActive.svg';
import fanGreenAsset from '@atom/components/common/svgIcons/fanGreenAsset.svg';
import fanGreenAssetActive from '@atom/components/common/svgIcons/fanGreenAssetActive.svg';
import fanOrangeAsset from '@atom/components/common/svgIcons/fanOrangeAsset.svg';
import fanOrangeAssetActive from '@atom/components/common/svgIcons/fanOrangeAssetActive.svg';
import fanRedAsset from '@atom/components/common/svgIcons/fanRedAsset.svg';
import fanRedAssetActive from '@atom/components/common/svgIcons/fanRedAssetActive.svg';
import fiberAsset from '@atom/components/common/svgIcons/fiberAsset.svg';
import fiberAssetActive from '@atom/components/common/svgIcons/fiberAssetActive.svg';
import fireHydrantBlueAsset from '@atom/components/common/svgIcons/fireHydrantBlueAsset.svg';
import fireHydrantBlueAssetActive from '@atom/components/common/svgIcons/fireHydrantBlueAssetActive.svg';
import fireHydrantGreenAsset from '@atom/components/common/svgIcons/fireHydrantGreenAsset.svg';
import fireHydrantGreenAssetActive from '@atom/components/common/svgIcons/fireHydrantGreenAssetActive.svg';
import fireHydrantRedAsset from '@atom/components/common/svgIcons/fireHydrantRedAsset.svg';
import fireHydrantRedAssetActive from '@atom/components/common/svgIcons/fireHydrantRedAssetActive.svg';
import flagBlackAsset from '@atom/components/common/svgIcons/flagBlackAsset.svg';
import flagBlackAssetActive from '@atom/components/common/svgIcons/flagBlackAssetActive.svg';
import flagBlueAsset from '@atom/components/common/svgIcons/flagBlueAsset.svg';
import flagBlueAssetActive from '@atom/components/common/svgIcons/flagBlueAssetActive.svg';
import flagPurpleAsset from '@atom/components/common/svgIcons/flagPurpleAsset.svg';
import flagPurpleAssetActive from '@atom/components/common/svgIcons/flagPurpleAssetActive.svg';
import flagWindBlackAsset from '@atom/components/common/svgIcons/flagWindBlackAsset.svg';
import flagWindBlackAssetActive from '@atom/components/common/svgIcons/flagWindBlackAssetActive.svg';
import flagWindBlueAsset from '@atom/components/common/svgIcons/flagWindBlueAsset.svg';
import flagWindBlueAssetActive from '@atom/components/common/svgIcons/flagWindBlueAssetActive.svg';
import flowerAsset from '@atom/components/common/svgIcons/flowerAsset.svg';
import flowerAssetActive from '@atom/components/common/svgIcons/flowerAssetActive.svg';
import flowMeterAsset from '@atom/components/common/svgIcons/flowMeterAsset.svg';
import flowMeterAssetActive from '@atom/components/common/svgIcons/flowMeterAssetActive.svg';
import genericAsset from '@atom/components/common/svgIcons/genericAsset.svg';
import genericAssetActive from '@atom/components/common/svgIcons/genericAssetActive.svg';
import greenCrossAsset from '@atom/components/common/svgIcons/greenCrossAsset.svg';
import greenCrossAssetActive from '@atom/components/common/svgIcons/greenCrossAssetActive.svg';
import heartAsset from '@atom/components/common/svgIcons/heartAsset.svg';
import heartAssetActive from '@atom/components/common/svgIcons/heartAssetActive.svg';
import heightAsset from '@atom/components/common/svgIcons/heightAsset.svg';
import heightAssetActive from '@atom/components/common/svgIcons/heightAssetActive.svg';
import holeAsset from '@atom/components/common/svgIcons/holeAsset.svg';
import holeAssetActive from '@atom/components/common/svgIcons/holeAssetActive.svg';
import houseAsset from '@atom/components/common/svgIcons/houseAsset.svg';
import houseAssetActive from '@atom/components/common/svgIcons/houseAssetActive.svg';
import houseGrayAsset from '@atom/components/common/svgIcons/houseGrayAsset.svg';
import houseGrayAssetActive from '@atom/components/common/svgIcons/houseGrayAssetActive.svg';
import houseOrangeAsset from '@atom/components/common/svgIcons/houseOrangeAsset.svg';
import houseOrangeAssetActive from '@atom/components/common/svgIcons/houseOrangeAssetActive.svg';
import houseYellowAsset from '@atom/components/common/svgIcons/houseYellowAsset.svg';
import houseYellowAssetActive from '@atom/components/common/svgIcons/houseYellowAssetActive.svg';
import hydrantAsset from '@atom/components/common/svgIcons/hydrantAsset.svg';
import hydrantAssetActive from '@atom/components/common/svgIcons/hydrantAssetActive.svg';
import linesAsset from '@atom/components/common/svgIcons/linesAsset.svg';
import linesAssetActive from '@atom/components/common/svgIcons/linesAssetActive.svg';
import liquidAsset from '@atom/components/common/svgIcons/liquidAsset.svg';
import liquidAssetActive from '@atom/components/common/svgIcons/liquidAssetActive.svg';
import manholeBlackAsset from '@atom/components/common/svgIcons/manholeBlackAsset.svg';
import manholeBlackAssetActive from '@atom/components/common/svgIcons/manholeBlackAssetActive.svg';
import manholeBlueAsset from '@atom/components/common/svgIcons/manholeBlueAsset.svg';
import manholeBlueAssetActive from '@atom/components/common/svgIcons/manholeBlueAssetActive.svg';
import manholeGreenAsset from '@atom/components/common/svgIcons/manholeGreenAsset.svg';
import manholeGreenAssetActive from '@atom/components/common/svgIcons/manholeGreenAssetActive.svg';
import medianAsset from '@atom/components/common/svgIcons/medianAsset.svg';
import medianAssetActive from '@atom/components/common/svgIcons/medianAssetActive.svg';
import paintAsset from '@atom/components/common/svgIcons/paintAsset.svg';
import paintAssetActive from '@atom/components/common/svgIcons/paintAssetActive.svg';
import parkingAsset from '@atom/components/common/svgIcons/parkingAsset.svg';
import parkingAssetActive from '@atom/components/common/svgIcons/parkingAssetActive.svg';
import pavementAsset from '@atom/components/common/svgIcons/pavementAsset.svg';
import pavementAssetActive from '@atom/components/common/svgIcons/pavementAssetActive.svg';
import pinBlueAsset from '@atom/components/common/svgIcons/pinBlueAsset.svg';
import pinBlueAssetActive from '@atom/components/common/svgIcons/pinBlueAssetActive.svg';
import pinGreenAsset from '@atom/components/common/svgIcons/pinGreenAsset.svg';
import pinGreenAssetActive from '@atom/components/common/svgIcons/pinGreenAssetActive.svg';
import pinOrangeAsset from '@atom/components/common/svgIcons/pinOrangeAsset.svg';
import pinOrangeAssetActive from '@atom/components/common/svgIcons/pinOrangeAssetActive.svg';
import pipeBlackAsset from '@atom/components/common/svgIcons/pipeBlackAsset.svg';
import pipeBlackAssetActive from '@atom/components/common/svgIcons/pipeBlackAssetActive.svg';
import pipeBlueAsset from '@atom/components/common/svgIcons/pipeBlueAsset.svg';
import pipeBlueAssetActive from '@atom/components/common/svgIcons/pipeBlueAssetActive.svg';
import pipePinkAsset from '@atom/components/common/svgIcons/pipePinkAsset.svg';
import pipePinkAssetActive from '@atom/components/common/svgIcons/pipePinkAssetActive.svg';
import pipeValveBlackAsset from '@atom/components/common/svgIcons/pipeValveBlackAsset.svg';
import pipeValveBlackAssetActive from '@atom/components/common/svgIcons/pipeValveBlackAssetActive.svg';
import pipeValveBlueAsset from '@atom/components/common/svgIcons/pipeValveBlueAsset.svg';
import pipeValveBlueAssetActive from '@atom/components/common/svgIcons/pipeValveBlueAssetActive.svg';
import pipeValveGreenAsset from '@atom/components/common/svgIcons/pipeValveGreenAsset.svg';
import pipeValveGreenAssetActive from '@atom/components/common/svgIcons/pipeValveGreenAssetActive.svg';
import questionAsset from '@atom/components/common/svgIcons/questionAsset.svg';
import questionAssetActive from '@atom/components/common/svgIcons/questionAssetActive.svg';
import railroadAsset from '@atom/components/common/svgIcons/railroadAsset.svg';
import railroadAssetActive from '@atom/components/common/svgIcons/railroadAssetActive.svg';
import signAsset from '@atom/components/common/svgIcons/signAsset.svg';
import signAssetActive from '@atom/components/common/svgIcons/signAssetActive.svg';
import sprinklerAsset from '@atom/components/common/svgIcons/sprinklerAsset.svg';
import sprinklerAssetActive from '@atom/components/common/svgIcons/sprinklerAssetActive.svg';
import squareAsset from '@atom/components/common/svgIcons/squareAsset.svg';
import squareAssetActive from '@atom/components/common/svgIcons/squareAssetActive.svg';
import squareBlueAsset from '@atom/components/common/svgIcons/squareBlueAsset.svg';
import squareBlueAssetActive from '@atom/components/common/svgIcons/squareBlueAssetActive.svg';
import squareGreenAsset from '@atom/components/common/svgIcons/squareGreenAsset.svg';
import squareGreenAssetActive from '@atom/components/common/svgIcons/squareGreenAssetActive.svg';
import squareOrangeAsset from '@atom/components/common/svgIcons/squareOrangeAsset.svg';
import squareOrangeAssetActive from '@atom/components/common/svgIcons/squareOrangeAssetActive.svg';
import starAsset from '@atom/components/common/svgIcons/starAsset.svg';
import starAssetActive from '@atom/components/common/svgIcons/starAssetActive.svg';
import stopSignAsset from '@atom/components/common/svgIcons/stopSignAsset.svg';
import stopSignAssetActive from '@atom/components/common/svgIcons/stopSignAssetActive.svg';
import sunAsset from '@atom/components/common/svgIcons/sunAsset.svg';
import sunAssetActive from '@atom/components/common/svgIcons/sunAssetActive.svg';
import trafficAsset from '@atom/components/common/svgIcons/trafficAsset.svg';
import trafficAssetActive from '@atom/components/common/svgIcons/trafficAssetActive.svg';
import treeAsset from '@atom/components/common/svgIcons/treeAsset.svg';
import treeAssetActive from '@atom/components/common/svgIcons/treeAssetActive.svg';
import upAsset from '@atom/components/common/svgIcons/upAsset.svg';
import upAssetActive from '@atom/components/common/svgIcons/upAssetActive.svg';
import valveAsset from '@atom/components/common/svgIcons/valveAsset.svg';
import valveAssetActive from '@atom/components/common/svgIcons/valveAssetActive.svg';
import vanBlackAsset from '@atom/components/common/svgIcons/vanBlackAsset.svg';
import vanBlackAssetActive from '@atom/components/common/svgIcons/vanBlackAssetActive.svg';
import vanBlueAsset from '@atom/components/common/svgIcons/vanBlueAsset.svg';
import vanBlueAssetActive from '@atom/components/common/svgIcons/vanBlueAssetActive.svg';
import vanGreenAsset from '@atom/components/common/svgIcons/vanGreenAsset.svg';
import vanGreenAssetActive from '@atom/components/common/svgIcons/vanGreenAssetActive.svg';
import walkAsset from '@atom/components/common/svgIcons/walkAsset.svg';
import walkAssetActive from '@atom/components/common/svgIcons/walkAssetActive.svg';
import wallAsset from '@atom/components/common/svgIcons/wallAsset.svg';
import wallAssetActive from '@atom/components/common/svgIcons/wallAssetActive.svg';
import warningAsset from '@atom/components/common/svgIcons/warningAsset.svg';
import warningAssetActive from '@atom/components/common/svgIcons/warningAssetActive.svg';
import warningBlackAsset from '@atom/components/common/svgIcons/warningBlackAsset.svg';
import warningBlackAssetActive from '@atom/components/common/svgIcons/warningBlackAssetActive.svg';
import warningBlueAsset from '@atom/components/common/svgIcons/warningBlueAsset.svg';
import warningBlueAssetActive from '@atom/components/common/svgIcons/warningBlueAssetActive.svg';
import warningOrangeAsset from '@atom/components/common/svgIcons/warningOrangeAsset.svg';
import warningOrangeAssetActive from '@atom/components/common/svgIcons/warningOrangeAssetActive.svg';
import waterAsset from '@atom/components/common/svgIcons/waterAsset.svg';
import waterAssetActive from '@atom/components/common/svgIcons/waterAssetActive.svg';
import waterTankBlackAsset from '@atom/components/common/svgIcons/waterTankBlackAsset.svg';
import waterTankBlackAssetActive from '@atom/components/common/svgIcons/waterTankBlackAssetActive.svg';
import waterTankBlueAsset from '@atom/components/common/svgIcons/waterTankBlueAsset.svg';
import waterTankBlueAssetActive from '@atom/components/common/svgIcons/waterTankBlueAssetActive.svg';
import waterTankGreenAsset from '@atom/components/common/svgIcons/waterTankGreenAsset.svg';
import waterTankGreenAssetActive from '@atom/components/common/svgIcons/waterTankGreenAssetActive.svg';
import weatherAsset from '@atom/components/common/svgIcons/weatherAsset.svg';
import weatherAssetActive from '@atom/components/common/svgIcons/weatherAssetActive.svg';

// Key matches the markerId
export const assetMarkers = {
  0: bridgeAsset,
  1: linesAsset,
  2: downAsset,
  3: upAsset,
  4: dotAsset,
  5: squareAsset,
  6: diamondAsset,
  7: heartAsset,
  8: genericAsset,
  9: bookmarkAsset,
  10: signAsset,
  11: treeAsset,
  12: waterAsset,
  13: benchAsset,
  14: deviceAsset,
  15: fanAsset,
  16: questionAsset,
  17: fiberAsset,
  18: liquidAsset,
  19: pavementAsset,
  20: barrierAsset,
  21: flowerAsset,
  22: warningAsset,
  23: starAsset,
  24: coneAsset,
  25: bulbAsset,
  26: trafficAsset,
  27: houseAsset,
  28: crossAsset,
  29: buildingAsset,
  30: busAsset,
  31: countAsset,
  32: walkAsset,
  33: medianAsset,
  34: bollardsAsset,
  35: sunAsset,
  36: bumpAsset,
  37: heightAsset,
  38: railroadAsset,
  39: curbAsset,
  40: boatAsset,
  41: weatherAsset,
  42: paintAsset,
  43: holeAsset,
  44: ditchAsset,
  45: wallAsset,
  46: bikeAsset,
  47: brushAsset,
  48: basinAsset,
  49: culvertAsset,
  50: curbStopAsset,
  51: hydrantAsset,
  52: parkingAsset,
  53: cleanOutAsset,
  54: controlValveAsset,
  55: flowMeterAsset,
  56: manholeBlueAsset,
  57: manholeBlackAsset,
  58: manholeGreenAsset,
  59: sprinklerAsset,
  60: valveAsset,
  61: backflowDeviceAsset,
  62: squareBlueAsset,
  63: squareGreenAsset,
  64: squareOrangeAsset,
  65: diamondBlueAsset,
  66: fanBlueAsset,
  67: fanOrangeAsset,
  68: fanGreenAsset,
  69: fanRedAsset,
  70: pipeBlueAsset,
  71: pipeBlackAsset,
  72: pipePinkAsset,
  73: fireHydrantBlueAsset,
  74: fireHydrantRedAsset,
  75: fireHydrantGreenAsset,
  76: buildingHydrantBlueAsset,
  77: buildingHydrantPinkAsset,
  78: buildingHydrantBlackAsset,
  79: pipeValveBlueAsset,
  80: pipeValveBlackAsset,
  81: pipeValveGreenAsset,
  82: waterTankBlueAsset,
  83: waterTankBlackAsset,
  84: waterTankGreenAsset,
  85: buildingBlackAsset,
  86: buildingOrangeAsset,
  87: buildingPurpleAsset,
  88: houseYellowAsset,
  89: houseOrangeAsset,
  90: houseGrayAsset,
  91: pinBlueAsset,
  92: pinOrangeAsset,
  93: pinGreenAsset,
  94: flagBlackAsset,
  95: flagBlueAsset,
  96: flagPurpleAsset,
  97: flagWindBlackAsset,
  98: flagWindBlueAsset,
  99: greenCrossAsset,
  100: warningBlackAsset,
  101: warningBlueAsset,
  102: warningOrangeAsset,
  103: dotBlueAsset,
  104: dotGreenAsset,
  105: dotOrangeAsset,
  106: vanBlueAsset,
  107: vanGreenAsset,
  108: vanBlackAsset,
  109: stopSignAsset,
};

// Key matches the markerId
export const activeAssetMarkers = {
  0: bridgeAssetActive,
  1: linesAssetActive,
  2: downAssetActive,
  3: upAssetActive,
  4: dotAssetActive,
  5: squareAssetActive,
  6: diamondAssetActive,
  7: heartAssetActive,
  8: genericAssetActive,
  9: bookmarkAssetActive,
  10: signAssetActive,
  11: treeAssetActive,
  12: waterAssetActive,
  13: benchAssetActive,
  14: deviceAssetActive,
  15: fanAssetActive,
  16: questionAssetActive,
  17: fiberAssetActive,
  18: liquidAssetActive,
  19: pavementAssetActive,
  20: barrierAssetActive,
  21: flowerAssetActive,
  22: warningAssetActive,
  23: starAssetActive,
  24: coneAssetActive,
  25: bulbAssetActive,
  26: trafficAssetActive,
  27: houseAssetActive,
  28: crossAssetActive,
  29: buildingAssetActive,
  30: busAssetActive,
  31: countAssetActive,
  32: walkAssetActive,
  33: medianAssetActive,
  34: bollardsAssetActive,
  35: sunAssetActive,
  36: bumpAssetActive,
  37: heightAssetActive,
  38: railroadAssetActive,
  39: curbAssetActive,
  40: boatAssetActive,
  41: weatherAssetActive,
  42: paintAssetActive,
  43: holeAssetActive,
  44: ditchAssetActive,
  45: wallAssetActive,
  46: bikeAssetActive,
  47: brushAssetActive,
  48: basinAssetActive,
  49: culvertAssetActive,
  50: curbStopAssetActive,
  51: hydrantAssetActive,
  52: parkingAssetActive,
  53: cleanOutAssetActive,
  54: controlValveAssetActive,
  55: flowMeterAssetActive,
  56: manholeBlueAssetActive,
  57: manholeBlackAssetActive,
  58: manholeGreenAssetActive,
  59: sprinklerAssetActive,
  60: valveAssetActive,
  61: backflowDeviceAssetActive,
  62: squareBlueAssetActive,
  63: squareGreenAssetActive,
  64: squareOrangeAssetActive,
  65: diamondBlueAssetActive,
  66: fanBlueAssetActive,
  67: fanOrangeAssetActive,
  68: fanGreenAssetActive,
  69: fanRedAssetActive,
  70: pipeBlueAssetActive,
  71: pipeBlackAssetActive,
  72: pipePinkAssetActive,
  73: fireHydrantBlueAssetActive,
  74: fireHydrantRedAssetActive,
  75: fireHydrantGreenAssetActive,
  76: buildingHydrantBlueAssetActive,
  77: buildingHydrantPinkAssetActive,
  78: buildingHydrantBlackAssetActive,
  79: pipeValveBlueAssetActive,
  80: pipeValveBlackAssetActive,
  81: pipeValveGreenAssetActive,
  82: waterTankBlueAssetActive,
  83: waterTankBlackAssetActive,
  84: waterTankGreenAssetActive,
  85: buildingBlackAssetActive,
  86: buildingOrangeAssetActive,
  87: buildingPurpleAssetActive,
  88: houseYellowAssetActive,
  89: houseOrangeAssetActive,
  90: houseGrayAssetActive,
  91: pinBlueAssetActive,
  92: pinOrangeAssetActive,
  93: pinGreenAssetActive,
  94: flagBlackAssetActive,
  95: flagBlueAssetActive,
  96: flagPurpleAssetActive,
  97: flagWindBlackAssetActive,
  98: flagWindBlueAssetActive,
  99: greenCrossAssetActive,
  100: warningBlackAssetActive,
  101: warningBlueAssetActive,
  102: warningOrangeAssetActive,
  103: dotBlueAssetActive,
  104: dotGreenAssetActive,
  105: dotOrangeAssetActive,
  106: vanBlueAssetActive,
  107: vanGreenAssetActive,
  108: vanBlackAssetActive,
  109: stopSignAssetActive,
};
